// cookieUtils.js

export const setCookie = (name, value, days) => {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);
  
    const cookieValue = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/`;
    document.cookie = cookieValue;
  };
  
  export const getCookie = (name) => {
    const cookieName = `${name}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
  
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
  
    return null;
  };
  
  // Function to get the cart items from the cookie
  export const getCartItems = () => {
    const cartItemsString = getCookie("cartItems");
    return cartItemsString ? JSON.parse(cartItemsString) : [];
  };
  export const getprice = () => {
    const cartItemsString = getCookie("totalprice");
    return cartItemsString ? JSON.parse(cartItemsString) : [];
  };
  
  // Function to set the cart items in the cookie
  export const setCartItems = (cartItems) => {
    setCookie("cartItems", JSON.stringify(cartItems), 364);
  };
  
  // Function to add a product to the cart
// Modify your addToCart function to include cakeDetails
export const addToCart = (userId, productId, quantity, formData) => {
  const cartItems = getCartItems();
  const existingCartItemIndex = cartItems.findIndex(item => item.userId === userId && item.productId === productId);
  
  if (existingCartItemIndex !== -1) {
    // If the product is already in the cart, update the quantity and cakeDetails
    cartItems[existingCartItemIndex].quantity = quantity;
    cartItems[existingCartItemIndex].cakeDetails = formData;
  } else {
    // If the product is not in the cart, add it with cakeDetails
    cartItems.push({ userId, productId, quantity, formData });
  }
  
  setCartItems(cartItems);
};


  // Function to remove a product from the cart
  export const removeFromCart = (productId) => {
    const cartItems = getCartItems();
    const updatedCartItems = cartItems.filter(item => item.productId !== productId);
    setCartItems(updatedCartItems);
  };
  
// Function to get the length of items in the cart
export const getCartItemsLength = () => {
  const cartItems = getCartItems();
  return cartItems.length;
};